/**
 * 模块名称：
 * @author ：XXXXX
 */
import { Toast } from 'vant';
import {
    getCardInfo,
    sendRongCloudmsg
} from '@/api/rongCloud.js'

const state = {

}
const mutations = {
    /**
     * 为state项赋值
     * @param state
     * @param data
     */
    setStateItem(state, data) {
        state[data.key] = data.value
    },

}
const actions = {
    /**
   * 获取卡片信息接口
   */
    async getCardInfo({ state, commit, dispatch }, data) {
        try {
            const res = await getCardInfo(data.data.data)
            if (res.data.code == 200) {
                data.cb(res.data.data, data.data)
            } else {
                Toast(res.data.message)
                return false
            }
        } catch (e) {
            return false
        }
    },
    /**
   * 融云发送消息
   */
    async sendRongCloudmsg({ state, commit }, data) {
        try {
            const res = await sendRongCloudmsg(data)
            if (res.data.code == 200) {
                data.content.msg_id = res.data.data
                data.cb(data)
                return false
            } else {
                Toast(res.data.message)
                return false
            }
        } catch (e) {
            return false
        }
    },

}
export default {
    state,
    actions,
    mutations,
    namespaced: true,
}
